


















import { Vue, Component } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'
import { REVISION_LOAD_MORE } from '@/store/revision/constants'
import { DiffedRevision } from '@/store/revision/types'
import RevisionListItem from './RevisionListItem.vue'

@Component({ components: { RevisionListItem }, name: 'revision-list' })
export default class RevisionList extends Vue {
    @Getter
    diffedRevisions!: DiffedRevision[]

    @Action(REVISION_LOAD_MORE)
    loadMoreRevisions!: () => Promise<void>

    get hasAllRevisions(): boolean {
        return this.diffedRevisions.filter(v => v.id === 0).length > 0
    }

    get changedRevisions(): DiffedRevision[] {
        return this.diffedRevisions.filter(v => Object.keys(v.diffs).length > 0 || v.message)
    }
}
